/**
 * Lookup API Service
 * Handles fetching lookup data (subjects, locations)
 */

import { apiClient } from './api';

export const lookupService = {
  /**
   * Fetch all available subjects
   * @returns {Promise<{results: Array}>}
   */
  async fetchSubjects() {
    return apiClient.get('/subjects/');
  },

  /**
   * Fetch all unique tutor locations
   * @returns {Promise<{results: Array}>}
   */
  async fetchLocations() {
    return apiClient.get('/locations/');
  },
};

export default lookupService;
